import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import { AuthResponse, InfoResponse } from "../FTypes";
export default class GameDataParser
    implements IBaseDataParser<IAuthorizationData>
{
    check(data: InfoResponse<unknown> & AuthResponse): boolean {
        return !!data.config;
    }

    parse(data: InfoResponse<unknown> & AuthResponse): IAuthorizationData[] {
        const result: IAuthorizationData = {
            serverGameConfig: {
                paylines: data.config.paylines,
                paytable: data.config.paytable,
                waysGame: false, // TODO: implement when we have such game
                defaultStopPositions: [0, 0, 0, 0, 0],
                rtp: data.config.rtp, // TODO: take from config probably?
                scatterReels: GameModel.gameConfig.scatterReels,
                freeSpinSymbol: 0, // TODO: get from config
            },
        };

        return [result];
    }
}
